import React from 'react'
import { Input } from '../../components/1elements'

const GuestLoginEmail = ({ value, onValueChange }) => {

  const handleChange = (e) => {
    onValueChange(e.target.value)
  }

  return (
    <Input
      onChange={handleChange}
      value={value}
      inputProps={{
        type: "email",
        name: "guestemail",
        maxLength: 10,
      }}
      placeholder={'Enter your email'}
  />
  )
}

export default GuestLoginEmail